export default {
    newPageCreateFile: "正在建立檔案",
    globalConfirm: "確定",
    globalCancel: "取消",
};
